import { useContext, useEffect, useState } from 'react';

import ArtworkDataContext from '@/context/ArtworkDataContext';
import { NextButton, PrevButton } from '@/shared-components/buttons/components/SliderControls';

import PicturesSlider from './components/PicturesSlider';

import './index.css';

export default function PicturesSection() {
  const { artworkData } = useContext(ArtworkDataContext);
  const [activeSlide, setActiveSlide] = useState(0);
  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    // Función para manejar la flecha izquierda
    const handleArrowLeft = (event) => {
      if (event.key === 'ArrowLeft') {
        swiper?.slidePrev();
      }
    };

    // Función para manejar la flecha derecha
    const handleArrowRight = (event) => {
      if (event.key === 'ArrowRight') {
        swiper?.slideNext();
      }
    };

    // Agregar los event listeners
    window.addEventListener('keydown', handleArrowLeft);
    window.addEventListener('keydown', handleArrowRight);

    // Cleanup: quitar los event listeners cuando el componente se desmonte
    return () => {
      window.removeEventListener('keydown', handleArrowLeft);
      window.removeEventListener('keydown', handleArrowRight);
    };
  }, [swiper]);
  
  return (
    <>
      <div className="artwork-view-pictures-section__container">
        <PicturesSlider setActiveSlide={setActiveSlide} setSwiper={setSwiper} />

        {artworkData.artwork_media.artwork_secondary_pictures.length > 0 && (
          <>
            <div className="artwork-view-pictures-slider__control-indicators-container">
              <div className="artwork-view-pictures-slider__control-outter prev" onClick={() => swiper?.slidePrev()}>
                <PrevButton className={`artwork-view-pictures-slider__control ${activeSlide === 0 ? "disabled" : ""}`} />
              </div>

              <div className="artwork-view-pictures-section__slide-indicators">
                <div className={`artwork-view-pictures-section__slide-indicator${activeSlide === 0 ? " active" : ""}`} />

                {artworkData.artwork_media.artwork_secondary_pictures.map((secondaryPicture, index) => (
                  <div key={secondaryPicture.image_id} className={`artwork-view-pictures-section__slide-indicator ${activeSlide === (index + 1) ? "active" : ""}`} />
                ))}
              </div>

              <div className="artwork-view-pictures-slider__control-outter next" onClick={() => swiper?.slideNext()}>
                <NextButton className={`artwork-view-pictures-slider__control ${activeSlide === artworkData.artwork_media.artwork_secondary_pictures.length ? "disabled" : ""}`} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
